import type { ServiceLanguage } from "@albertine/i18n";
import { tenantConfig } from "@albertine/tenant-config";
import type { Tenant } from "@albertine/types/openapi/lmt";

export function formatTenantName(tenant: Tenant): string {
    return tenantConfig[tenant].lmt.tenantName;
}

export function areTrialsEnabled(tenant: Tenant): boolean {
    return tenantConfig[tenant].lmt.trialsEnabled;
}

export function getTenantServiceLanguages(tenant: Tenant): ServiceLanguage[] {
    return tenantConfig[tenant].allowedServiceLanguages;
}
